import React from 'react';

import fetch from './fetch';

import moment from 'moment';

import utils from './../utils';

import {Modal, message} from 'antd';

const transform = (data) => {
    return data.map((d) => {
        var current = {
            title: d.label,
            key: d.id + '',
            value: d.id + '',
            selected: d.selected
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'roleId', label: '角色ID'},
    {key:'roleName', label: '角色名称'},
    {key:'roleType', label: '角色类型', render: (type) => {
        return type === 1 ? '系统定义' : '用户定义';
    }},
    {key:'roleLimitsName', label: '角色定义类型'},
    {key:'createUserName', label: '创建人'},
    {key:'roleDesc', label: '角色描述', width: 240},
]);

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('role/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('role/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.roleId,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/*
    "codeId": 33,
    "codeType": "SYS_LIMITS",
    "codeName": "系统管理员权限",
    "codeValue": "10000",
    "codePid": 32,
    "codeLevel": 3
 */
const querySysLimits = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('platform/code/sys/limits', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        var list = data.map(function(d) {
            return {
                value: d.codeValue,
                label: d.codeName
            }
        });

        list.unshift({
            value: '',
            label: '自定义角色'
        })
        return list;
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('role/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '信息添加成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到管理页面！</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('role/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '信息更新成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到管理页面！</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('role/remove/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

//role/view/permission

/**
 * @method queryRoleTree
 * @param {object} [keywords]
 * @return {promise}
 */
const queryRoleTree = (roleId) => {
    return fetch.post('role/view/permission/'+ roleId, {})
    .then(response => response.payload.data)
    .then(result => {
        const treeData = transform(utils.tree(result));

        const checkedKeys = result.filter(d => {
            return d.selected
        }).map(d => {
            return d.id;
        });

        return {
            treeData,
            checkedKeys
        };
    })
}

/**
 * @method queryRoleTree
 * @param {object} [keywords]
 * @return {promise}
 */
const saveRoleTree = (data) => {
    return fetch.post('role/save/permission', data)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }
    });
}


/**
 * @method queryRoleTree
 * @param {object} [keywords]
 * @return {promise}
 */
const saveRoleEmployee = (data) => {
    return fetch.post('role/save/roleEmployee', data)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }
    });
}

/**
 * @method queryRoleTree
 * @param {object} [keywords]
 * @return {promise}
 */
const removRoleEmployee = (data) => {
    return fetch.post('role/remove/roleEmployee', data)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'role'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const saveRoleStudent = (data) => {
    return fetch.post('role/save/roleStudent', data)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }
    });
}

const removeRoleStudent = (data) => {
    return fetch.post('role/remove/roleStudent', data)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }
    });
}


const saveRoleMaster = (data) => {
    return fetch.post('role/save/roleMaster', data)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }
    });
}

/**
 * @method querySearchByName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByName = (keywords ={}) => {
    return fetch.post('role/find/by/name', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.roleId,
            label: d.roleName
        }));
    });
}

export default {
    insertURL: '#/role/insert',
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    querySysLimits,
    getSelection,
    queryRoleTree,
    saveRoleTree,
    saveRoleEmployee,
    removRoleEmployee,
    saveRoleStudent,
    removeRoleStudent,
    saveRoleMaster,
    querySearchByName
}